import React from 'react'

import { topUps } from '../redux'

import TopUpsList from '../components/TopUpsList'

const TopUpsContainer = () => (
    <TopUpsList dataSelector={ topUps.getAll } />
)

export default TopUpsContainer
